import { useWebsite } from "@/lib/website";

export default function WhatsAppFab() {
  const { content } = useWebsite();
  const num = content.contact.whatsapp_enabled ? content.contact.whatsapp_number : "";
  if (!num) return null;
  const digits = num.replace(/[^0-9]/g, "");
  const href = `https://wa.me/${digits}?text=${encodeURIComponent("Hi BookGhost, I have a question about my book.")}`;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 z-40 bg-[#25D366] hover:bg-[#1ea955] text-white rounded-full shadow-lg h-14 w-14 flex items-center justify-center"
      aria-label="Chat on WhatsApp">
      <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.36c-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.14-.61.14-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.14-1.13-.42-2.15-1.32-.79-.7-1.32-1.57-1.48-1.84-.16-.27-.02-.42.12-.55.13-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.61-1.48-.84-2.03-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.26 0 1.33.97 2.62 1.11 2.8.14.18 1.92 2.93 4.65 4.11.65.28 1.16.45 1.56.58.65.21 1.24.18 1.71.11.52-.08 1.6-.65 1.83-1.28.22-.63.22-1.17.16-1.28-.07-.11-.25-.18-.52-.32zM16.02 4C9.37 4 4 9.37 4 16.02c0 2.11.55 4.16 1.6 5.98L4 28l6.13-1.61a11.94 11.94 0 0 0 5.89 1.5h.01C22.68 27.9 28.05 22.53 28.05 15.88 28.05 9.24 22.66 4 16.02 4z" />
      </svg>
    </a>
  );
}
